import {z} from 'zod'
import {AgendaConsultantSelector} from '@/features/agenda/components/agenda-consultant-selector/AgendaConsultantSelector'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useFieldArray, useFormContext, useWatch} from 'react-hook-form'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {AgendaEventAccessTypeSelector} from '@/features/agenda/components/agenda-event-form/agenda-event-access-type-selector/AgendaEventAccessTypeSelector'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {PlusIcon, Trash01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'

const AgendaEventConsultantFieldsSchema = AgendaEventFieldsSchema.pick({
    consultants: true,
    accessType: true,
    isGroupTreatment: true,
    patients: true
})
type AgendaEventConsultantFieldsSchema = z.infer<typeof AgendaEventConsultantFieldsSchema>

export const AgendaEventConsultantFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AgendaEventConsultantFieldsSchema>()
    const {fields, append, remove} = useFieldArray({control, name: 'consultants', keyName: 'key'})
    const isGroupTreatment = useWatch({control, name: 'isGroupTreatment'})
    const patients = useWatch({control, name: 'patients'})

    return (
        <>
            {fields.map((field, index) => (
                <Grid columns={2} gap={4} key={field.key} style={{alignItems: 'flex-start'}}>
                    <Flexbox gap={2} align="flex-end">
                        <Flexbox direction="column" gap={1.5} fullWidth>
                            <AgendaConsultantSelector value={field} index={index} />
                        </Flexbox>
                        {fields.length > 1 && (
                            <Button type="button" variant="secondary" shape="square" onClick={() => remove(index)}>
                                <Trash01Icon />
                            </Button>
                        )}
                    </Flexbox>
                    <AgendaEventAccessTypeSelector index={index} />
                </Grid>
            ))}
            {isGroupTreatment && fields.length < 2 && (
                <Button
                    type="button"
                    variant="secondary"
                    size="sm"
                    disabled={!patients || patients?.length == 0}
                    style={{width: 'fit-content'}}
                    onClick={() => {
                        append({
                            id: '',
                            fullName: ''
                        })
                    }}
                >
                    <PlusIcon />
                    {t('commons:consultant')}
                </Button>
            )}
        </>
    )
}
